import React from "react";
import { Route } from "react-router-dom";
import {
  IndexQuotes,
  QuotesCreate,
  QuotesEdit,
  QuotesMain,
  QuotesView,
} from "../Views/Web/Client Management/Quotes/Index";
import MainQuotesman from "../Views/Web/Client Management/MainQuotesman";

function QuotationRoutes() {
  return (
    <Route path="quotation" element={<MainQuotesman />}>
      <Route path="quote" element={<QuotesMain />}>
        <Route index element={<IndexQuotes />} />
        <Route path="create" element={<QuotesCreate />} />
        <Route path="edit/:quotesEditId" element={<QuotesEdit />} />
        <Route path="view/:quotesViewId" element={<QuotesView />} />
      </Route>
    </Route>
  );
}

export default QuotationRoutes;